export const SET_LOADING = "SET_LOADING"
export const SET_USER_INFO = "SET_USER_INFO"

export const GET_USER_INFO = "GET_USER_INFO"
export const GET_USER_INFO_REQUEST = "GET_USER_INFO_REQUEST"
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS"
export const GET_USER_INFO_ERROR = "GET_USER_INFO_ERROR"

export const RESET_USER_DATA = "RESET_USER_DATA"
